import template from './positionDisplayBox.html';
import controller from './positionDisplayBox.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    staffUser: '<',
    position: '=',
    lockForMandatoryCheckIn: '<',
    otherPositionCheckedIn: '<',
    positionRequiringClaim: '<',
    allowCheckin: '<',
  }
};

export default component;
